import { useEffect } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { HiOutlineSparkles } from 'react-icons/hi2';

import DashLayout from '../../components/DashLayout';
import { EmptyState } from '../../components/EmptyState';
import { ListaNovidades } from '../../components/Novidades';
import { PageHeader } from '../../components/PageHeader';
import { useNovidades } from '../../hooks/useNovidades';

/**
 * Mural com tudo o que mudou no sistema, escrito para quem usa e nao para quem
 * desenvolve. Abrir a pagina ja conta como leitura, entao o aviso do menu some.
 */
export const Novidades = () => {
	const { versoes, marcarComoLidas } = useNovidades();

	useEffect(
		() => {
			marcarComoLidas();
		},
		[ marcarComoLidas ]
	);

	return (
		<DashLayout>
			<Flex width="100%" height="100%" flexDir="column">
				<PageHeader title="Novidades do sistema">
					<Text fontSize="14px" fontWeight="400" color="gray.600">
						O que mudou no sistema, da entrega mais recente para a mais antiga.
					</Text>
				</PageHeader>
				<Flex flex="1" overflowY="auto" justifyContent="center" p={{ base: 4, md: 6 }}>
					<Box width="100%" maxWidth="820px">
						{versoes.length > 0 ? (
							<Box
								bg="white"
								border="1px solid"
								borderColor="mist"
								borderRadius="14px"
								boxShadow="sm"
								p={{ base: '20px', md: '28px' }}
							>
								<ListaNovidades versoes={versoes} />
							</Box>
						) : (
							<EmptyState
								icon={HiOutlineSparkles}
								title="Nenhuma novidade por aqui"
								description="Assim que uma atualização for publicada, ela aparece nesta tela."
							/>
						)}
					</Box>
				</Flex>
			</Flex>
		</DashLayout>
	);
};
